// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"41cf76c4","187":"c5457d33","359":"24925971","375":"3777a121","430":"dbd8b392","453":"c302336a","472":"9992de0e","577":"4ebfb85a","656":"9243933c","783":"3eb337c7","936":"97aa7e3c","981":"7390178f"}[chunkId] + ".chunk.js";
};